import React from "react";
import images from './../../../../helper/images';

const ImpartRecentAnalysis = () => {
    const render = () => {
        return (
            <section class="py-5">
                <div class="container">
                    <div class="text-blue font-18 mb-3">Recent Analyses</div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="Recent-Analyses-box p-4 border">
                                <div class="d-flex align-items-center justify-content-between mb-4">
                                    <div>
                                        <div><b>Content Title </b></div>
                                        <div><b>Analyze Context : </b> Average Multiplayer</div>
                                    </div>
                                    <div><img src={images.video} alt="video" /></div>
                                </div>
                                <div class="d-flex gap-15">
                                    <div class="w-50">
                                        <div class="Recent-Analyses-sub-box p-3 text-center">
                                            <div class="text-black"><b>Predicted Success Score </b></div>
                                            <div class="text-blue Recent-Analyses-sub-box-heading">80%</div>
                                        </div>
                                    </div>
                                    <div class=" w-50">
                                        <div class="Recent-Analyses-sub-box p-3 text-center">
                                            <div class="text-black"><b>Engagement Level  </b></div>
                                            <div class="text-blue Recent-Analyses-sub-box-heading">Strong</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right mt-3" style={{ color: '#666' }}>04.10.25</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
    return render();
}

export default ImpartRecentAnalysis